// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Favorites_wrap__OcrB6","grid":"Favorites_grid__3VLct"};